import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import { BoatDetails } from './BoatDetails';
import * as Icons from 'react-bootstrap-icons';
import { remove, selectBaseBoat } from './boatListSlice';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../app/store';
import { BoatDetailsEdit } from '../boatDetailsEdit/BoatDetailsEdit';

export interface BoatDetailsCardProps {
  boat: BoatDetails;
  baseBoat: boolean;
}

export function BoatDetailsCard(props: BoatDetailsCardProps) {
  const dispatch: AppDispatch = useDispatch();

  const [showEditor, setShowEditor] = useState(false);

  const handleClose = () => setShowEditor(false);
  const handleShow = () => setShowEditor(true);

  function editDetails() {
    console.log(`BoatDetailsCard.editDetails ${props.boat.id}`);
    handleShow();
  }

  function deleteDetails() {
    console.log('BoatDetailsCard.deleteDetails');
    if (window.confirm(`Delete details for ${props.boat.name}`)) {
      dispatch(remove(props.boat));
    }
  }

  function setBaseBoat() {
    console.log('BoatDetailsCard.setBaseBoat');
    dispatch(selectBaseBoat(props.boat.id));
  }

  return <>
    <BoatDetailsEdit
      show={showEditor}
      handleClose={handleClose}
      boat={props.boat} />
    <Card>
      <Card.Header>
        {props.boat.name}
        <div className='float-end'>
          <Icons.Pencil onClick={editDetails} className='cursor-pointer' />
          &nbsp;
          <Icons.Trash onClick={deleteDetails} className='cursor-pointer' />
          &nbsp;
          {
            props.baseBoat ?
              <Icons.StarFill onClick={setBaseBoat} className='cursor-pointer' /> :
              <Icons.Star onClick={setBaseBoat} className='cursor-pointer' />
          }
        </div>
      </Card.Header>
      <Card.Body>
        <Card.Text>Handicap {props.boat.handicap}</Card.Text>
      </Card.Body>
    </Card>
  </>;
}
